import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, c2, c5, r1, r2, sImaginary) {
  var result = Complex.createComplex(r2, sImaginary * r2 * (c1 * r1 + c2 * r1 + c5 * r1)).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c1, c2, c5, r1, r2, rOut, sImaginary, sSquared) {
  var complexFFNumerator = Complex.createComplex(
    rOut * (sSquared * c2 * c5 * r1 * r2 + 1),
    sImaginary * rOut * (c1 * r1 + c2 * r1 + c5 * r1),
  );
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
